// Türkçe: 'Soera's leren' web metinleri (golf 7). Ebeveyne sen-vorm (app.tr.ts ile aynı). Bir
// {naam}'dan sonra ek yok. POORT: moedertaalreview en een hoca voor de woordkeuze.
export const appMemorizeTr = {
    title: 'Sure ezberi',
    nav: 'Ezber',
    card: {
        body: "Çocuklarının hangi sureleri ezberlediğini takip et. Çocuk dinletir, sen gerçekten dinlersin ve 'Güzelce dinledim' dersin. Puanlar ancak o zaman gelir.",
        question: 'Takip edilsin mi?',
        yes: 'Evet',
        notNow: 'Hayır, şimdi değil',
        notNowDone: 'Tamam. Buradan istediğin zaman açabilirsin.',
        on: 'Açık: {names}.',
        open: 'Ezbere git',
        settings: 'Ayarlar',
        renewal: 'Önce Ailemize uyan bölümünde yeniden onay ver.',
    },
    wizard: {
        title: 'Sure ezberini aç',
        step: 'Adım {n} / 4',
        back: 'Geri',
        next: 'İleri',
        done: 'Aç',
        who: {
            title: 'Kimler katılıyor?',
            body: 'Kimlerin katılacağını aç. Senin karar verdiğin, 16 yaşından küçük çocuklar.',
            teen: 'Karar veren: {name}. Bu daha sonra gelecek.',
            otherFaith: 'İnanç konusunda kendi seçimi var: {name}. Katılmıyor.',
            none: 'Ailede 16 yaşından küçük çocuk yok.',
            pick: 'En az bir çocuğu aç.',
            and: 've',
            joins: 'Katılıyor',
            paused: 'Şu an katılmıyor. İlerleme saklanır.',
            notYet: 'Katılmıyor',
            toggle: 'Katılıyor: {name}',
            later: 'Açmak, önce o çocuk için onayını ister. Kapatmak ilerlemeyi saklar.',
            more: 'Başka biri de katılsın mı?',
            choose: 'Çocukları seç',
            turnedOn: 'Katılıyor: {name}.',
            turnedOff: 'Şu an katılmıyor: {name}. İlerleme saklanır.',
        },
        naming: {
            title: 'Surelere nasıl diyorsunuz?',
            turkish: 'Fâtiha, İhlâs, Kevser',
            arabic: 'Al-Fatiha, Al-Ikhlas, Al-Kawthar',
            order: 'Sıra',
            recommended: 'Önerilen: {fatiha}, sonra en kısalar',
            prayer: 'Namaz sırası: Fâtiha, Fîl’den Nâs’a',
        },
        board: {
            title: 'Panoda gösterilsin mi?',
            body: 'Panonun önünde duran herkes bunu seçili çocukta görür.',
            yes: 'Evet, panoda',
            no: 'Hayır, sadece uygulamada',
        },
        known: {
            title: 'Her çocuk neyi zaten biliyor?',
            body: 'Çocuğun zaten ezbere bildiklerini işaretle. Bunun için puan ve kutlama yok.',
        },
    },
    consent: {
        title: 'Onay: {name}',
        text: 'Yalnızca aileniz için, {name} için hangi sureleri öğrendiğini ve bildiğini takip ediyoruz. Bunu her zaman geri alabilirsin; o zaman ilerlemeyi sileriz.',
        check: 'Ebeveyni veya vasisiyim ({name}) ve buna onay veriyorum.',
        textMany: 'Yalnızca aileniz için, {name} için hangi sureleri öğrendiklerini ve bildiklerini takip ediyoruz. Bunu her zaman geri alabilirsin; o zaman ilerlemeyi sileriz.',
        checkMany: '{name} için ebeveyn veya vasiyim ve buna onay veriyorum.',
        give: 'Onay ver',
        withdraw: 'Onayı geri al',
        withdrawConfirm: 'Onay geri alınsın mı ({name})? Bu, ilerlemeyi hemen siler. Kazanılan puanlar kalır.',
        withdrawn: 'Onay geri alındı. İlerleme silindi ({name}).',
        given: 'Onay tarihi: {date}.',
        none: 'Henüz onay yok',
    },
    stage: {
        none: 'Henüz başlanmadı',
        learning: 'Öğreniyor',
        ready: 'Dinletmek istiyor',
        known: 'Ezberlendi',
        review: 'Biraz tekrar',
    },
    overview: {
        subtitle: 'Çocukların ezberlediği sureler. Her çocuk kendi hızında.',
        now: 'Şu an: {item}',
        nothing: 'Henüz bir şey başlanmadı',
        next: 'Sıradaki: {item}',
        allKnown: 'Listenin tamamı ezberlendi ({name})',
        waiting: 'Dinlenmeyi bekliyor ({count})',
        refresh: 'Tekrar: {items}',
        list: 'Liste',
        settings: 'Ayarlar',
        open: 'Görüntüle',
        paused: 'Sure ezberi kapalı. Kapatmak şimdi hiçbir şeyi silmez. 12 ay kapalı kalırsa ilerleme silinir.',
        notSet: 'Sure ezberi henüz açık değil.',
        setUp: 'Aç',
        noConsent: 'Henüz onay yok',
        disabled: 'Şu an katılmıyor',
        selfDecides: 'Kendi karar veriyor; daha sonra gelecek',
    },
    member: {
        progress: '{x} / {y} ezberlendi',
        orderLearn: 'Öğrenme sırası',
        orderMushaf: 'Mushaf sırası',
        menu: '{item} için ne yapmak istiyorsun?',
        start: 'Başla',
        ready: 'Dinletmek istiyor',
        approve: 'Güzelce dinledim',
        practice: 'Biraz daha çalışsın',
        markKnown: 'Bunu dinletti',
        baseline: 'Bunu zaten biliyordu',
        refresh: 'Biraz tekrar',
        heard: 'Güzelce dinledim',
        revert: 'Yanlışlıkla onaylandı',
        revertConfirm: 'Geri alınsın mı? {item} sonra yine Öğreniyor durumunda olur.',
        revertPoints: '{item} için {count} puan geri alınır.',
        negative: 'O zaman bakiye eksiye düşer ({name}). Yine de geri alınsın mı?',
        reset: 'Sil',
        resetConfirm: '{item} silinsin mi ({name})? Sonra yine Henüz başlanmadı olur.',
        confirm: 'Evet',
        cancel: 'Hayır',
        upto: 'Şu ayete kadar',
        uptoHint: 'Daha uzun bir surede: {name} nereye kadar biliyor?',
        uptoSave: 'Kaydet',
        uptoClear: 'Temizle',
        uptoShort: '{n}. ayete kadar',
        listen: 'Quran.com’da dinle',
        verses: { one: '{count} ayet', other: '{count} ayet' },
        points: { one: '{count} puan', other: '{count} puan' },
        reviewRound: 'Tekrar turu',
        reviewRoundBody: 'Ezberlenmiş birkaç tanesini yeniden dinle. Puan yok, sadece biraz tekrar.',
        reviewRoundEmpty: 'Şu an tekrar edilecek bir şey yok.',
        reviewRoundDone: 'Tekrar turu bitti.',
        inactive: 'Artık listede değil',
        extra: 'Ek',
        heardBy: 'Dinleyen',
        heardParent: 'ben',
        heardTeacher: 'öğretmen (hoca)',
        milestones: 'Kilometre taşları',
        divider: 'Namaz sureleri',
        milestone: {
            fatiha: '{fatiha} ezberlendi',
            prayer_set: 'Namaz sureleri tamam',
            starter_set: 'İlk yirmi sure tamam',
        },
        done: 'Kaydedildi.',
        childBody: 'Başlamak ya da dinletmek için düğmeye dokun.',
        childStart: 'Bunu ezberlemeye başlıyorum',
        childReady: 'Bunu ezberledim',
        childOops: 'Geri al',
        childReadyDone: 'Güzel. Birazdan bir büyüğün dinleyecek.',
        agedOut: '16 yaşından itibaren {name} kendisi karar verir. Kaydedince sure ezberindeki ilerleme silinir ({name}); puanlar kalır.',
        /** Golf 7 live r1: bevestiging vóór een geboortedatum die een meedoend kind 16+ maakt. */
        agedOutBirth: {
            title: 'Doğum tarihi kaydedilsin mi?',
            body: 'Bu doğum tarihiyle {name} 16 yaşında ya da daha büyük. 16 yaşından itibaren {name} kendisi karar verir: kaydedince sure ezberindeki ilerleme silinir ({name}). Puanlar kalır.',
            confirm: 'Kaydet ve sil',
        },
    },
    list: {
        body: 'Puanlar bütün çocuklar için aynıdır.',
        rewardsOff: 'Ödüller kapalı: puan verilmiyor.',
        up: '{item} yukarı',
        down: '{item} aşağı',
        drag: 'Taşımak için sürükle',
        active: 'Listede',
        points: 'Puan',
        presets: 'Tek dokunuşla sıra',
        recommended: 'Önerilen',
        prayer: 'Namaz sırası',
        more: 'Daha fazla ekle',
        moreBody: 'Ek: Âyete’l-Kürsî (bir ayet, sure değil). Ve 95’ten 78’e kadar olan sureler.',
        add: 'Ekle',
        remove: 'Listeden çıkar',
        save: 'Listeyi kaydet',
        saved: 'Liste kaydedildi.',
        keptNote: 'İlerleme olduğu için saklanıyor.',
    },
    settings: {
        naming: 'İsimler',
        namingTurkish: 'Türkçe: Fâtiha, İhlâs, Kevser',
        namingArabic: 'Arapça: Al-Fatiha, Al-Ikhlas, Al-Kawthar',
        riwaya: 'Kıraat',
        hafs: 'Hafs',
        warsh: 'Verş',
        warshNote: 'Verş’te ayet numarası ve bağlantı göstermiyoruz: bu sayım baskıya göre değişir.',
        refresh: 'Tekrar zamanı',
        days: '{count} gün sonra',
        never: 'Hiç',
        board: 'Panoda göster',
        boardNote: 'Panonun önünde duran herkes bunu seçili çocukta görür.',
        consent: 'Her çocuk için onay',
        wipe: 'Herkesin ilerlemesini sil',
        wipeBody: 'Bütün ilerlemeyi, listeyi ve ayarları siler, onayları geri alır. Kazanılan puanlar kalır.',
        wipeConfirm: 'Her şey silinsin mi? Bu geri alınamaz.',
        wiped: 'Sure ezberi silindi.',
        off: 'Kapat',
        offNote: 'Kapatmak şimdi hiçbir şeyi silmez. 12 ay kapalı kalırsa ilerleme silinir.',
        on: 'Yeniden aç',
        pointsNote: 'Silindikten sonra kazanılan puanlar kalır. Daha sonra yeniden açarsan bir sure yeniden puan verebilir.',
        saved: 'Kaydedildi.',
    },
    approvals: {
        title: 'Dinletme',
        wants: '{name}, {item} dinletmek istiyor',
        wantsAgain: '{name}, {item} yeniden dinletmek istiyor',
        since: '{time}',
        points: {
            one: 'Güzelce dinledim ile {count} puan',
            other: 'Güzelce dinledim ile {count} puan',
        },
        approve: 'Güzelce dinledim',
        practice: 'Biraz daha çalışsın',
        heardBy: 'Dinleyen',
        me: 'ben',
        teacher: 'öğretmen (hoca)',
        already: 'Zaten yapıldı.',
        approved: '{item}: güzelce dinletildi.',
        practiced: 'Biraz daha çalışsın. {name} daha sonra yeniden dinletebilir.',
        seen: 'Gördüm',
        milestone: '{name}: {text}',
    },
    errors: {
        stale_stage: 'Zaten yapıldı.',
        revert_first: 'Önce Yanlışlıkla onaylandı ile geri al.',
        not_eligible: 'Bu çocuk (henüz) katılmıyor.',
        consent_renewal_required: 'Önce Ailemize uyan bölümünde yeniden onay ver.',
    },
};
//# sourceMappingURL=memorizeApp.tr.js.map